export var handleRTL = function (controllerParams) { return function () {
    controllerParams.controllerConfig.setProps({ isRTL: controllerParams.flowAPI.environment.isRTL });
}; };
//# sourceMappingURL=handleRTL.js.map